var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Что это такое?!"}},[_c('b-card-text',[_vm._v("Мы просто ничего не придумали, что можно было бы сюда написать.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }